import { render, staticRenderFns } from "./AddEditCaseTask.vue?vue&type=template&id=4f4429f9&scoped=true"
import script from "./AddEditCaseTask.vue?vue&type=script&lang=js"
export * from "./AddEditCaseTask.vue?vue&type=script&lang=js"
import style0 from "./AddEditCaseTask.vue?vue&type=style&index=0&id=4f4429f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4429f9",
  null
  
)

export default component.exports